import React from 'react';
import { motion } from 'framer-motion';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>About Me</h2>
          <div className="underline"></div>
        </motion.div>

        <motion.div
          className="about-content"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="about-text">
            <p>
              I am shristi , B.Tech CSE Final Year Student of Sikkim Manipal Institute of Technology with the CGPA of 9.42. 
              I am passionate about software engineering, backend development, and AI engineering.
              I enjoy solving complex problems using first-principles thinking and building scalable, efficient systems.
            </p>
            <p>
              With a strong foundation in computer science and hands-on experience in various technologies,
              I strive to create innovative solutions that make a difference. My journey in tech has been driven
              by curiosity and a desire to continuously learn and grow.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;